module.exports = __webpack_public_path__ + "img/Service_content_1.4006dc48.png";